var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:rgba(112,112,112,0.4);stroke-width:0.5px;}.b{fill:#52514f;}.c{stroke:none;}.d{fill:none;}.e{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 12,
    cy: 12,
    r: 11.75
  }))), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M951.656,761.428l-3.747-4.028,3.747-4.028-.9-.972-4.651,5,4.651,5Z",
    transform: "translate(-745.4 962.656) rotate(-90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpanIcon);
export default __webpack_public_path__ + "static/media/ExpanIcon.18ddae40584cd71df3aa148d85b2922d.svg";
export { ForwardRef as ReactComponent };